
import { Link } from 'react-router-dom';

const HowItWorksSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Search Products',
      description: 'Find any product you want to track from millions of items across top retailers.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Compare Prices',
      description: 'See prices from multiple stores side-by-side and find the best deal instantly.',
      icon: 'ri-scales-3-line'
    },
    {
      number: '03',
      title: 'Set Price Alerts',
      description: 'Choose your target price and we will notify you when it drops.',
      icon: 'ri-notification-3-line'
    },
    {
      number: '04',
      title: 'Save Money',
      description: 'Buy at the perfect time and save big on every purchase.',
      icon: 'ri-money-dollar-circle-line'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-teal-400 uppercase tracking-wider">How It Works</span>
          <h2 className="text-3xl lg:text-4xl font-bold mt-3 mb-4">
            Start Saving in 4 Simple Steps
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Join thousands of smart shoppers who save money every day with Ohprice.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-teal-500/30 to-transparent -translate-y-1/2"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative group">
                {/* Card */}
                <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700 hover:border-teal-500/50 transition-all duration-300 h-full">
                  {/* Step Number */}
                  <div className="flex items-center justify-between mb-6">
                    <span className="text-5xl font-bold text-gray-700 group-hover:text-teal-500/30 transition-colors">
                      {step.number}
                    </span>
                    <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                      <i className={`${step.icon} text-white text-xl`}></i>
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{step.description}</p>
                </div>

                {/* Arrow (hidden on last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-8 h-8 items-center justify-center">
                    <i className="ri-arrow-right-line text-teal-500 text-xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-xl font-semibold hover:from-teal-600 hover:to-emerald-600 transition-all cursor-pointer whitespace-nowrap transform hover:scale-105"
          >
            Start Comparing Prices
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
